module.exports = __webpack_public_path__ + "img/chengyun5.c9ebee79.png";